// bao migrate skip
import * as $ from "jquery";
import * as ko from "knockout";
import TabViewModel from "./../factories/tab-controller";
import TabPage from "./../factories/tab-page";
import Bao from "./../services/bao-service";
import baoTabContainer from "./bao-tabs-container.html";
import baoTabHeader from "./bao-tabs-header.html";
Bao.Templates.baoTabHeader = baoTabHeader;
Bao.Templates.baoTabContainer = baoTabContainer;
ko.bindingHandlers.baoTabs = {
	init: function (element, valueAccessor, allBindingsAccessor, viewModel, bindingContext) {
		const tabsLength = $("ul li", element).length;
		let tabViewModel = ko.utils.unwrapObservable(valueAccessor());
		if (tabViewModel == null || ko.isObservable(valueAccessor()) && valueAccessor()() == null) {
			tabViewModel = new TabViewModel(false);
			if (ko.isObservable(valueAccessor())) {
				valueAccessor()(tabViewModel);
			}
		}
		if (tabsLength > 0) {
			const foundNewTabs = [];
			for (let tabIndex = 0; tabIndex < tabsLength; tabIndex++) {
				const newTab = new TabPage();
				newTab.AutoSelect = tabIndex == 0;
				newTab.Title($("li > a > span", element).eq(tabIndex).text());
				newTab.Url($("li > a", element).eq(tabIndex).attr("href"));
				newTab.IsClosable(false);
				newTab.TemplateName(newTab.Id());
				newTab.ViewModel(viewModel);
				tabViewModel.AddTab(newTab);
				const $tabContainer = $(element).children("div").eq(tabIndex);
				if ($tabContainer != null) {
					Bao.Templates[newTab.Id()] = $tabContainer.html();
				}
			}
		}
		ko.utils.domNodeDisposal.addDisposeCallback(element, function () {
			tabViewModel.DestroyAll();
			$(element).empty();
		});
		$(element).empty();
		$(element).append("<ul class=\"nav nav-tabs\" data-bind=\"template: {name: 'baoTabHeader', foreach: Tabs}\"></ul>");
		$(element).append("<div class=\"baoTabContainer\" data-bind=\"template: {name: 'baoTabContainer', foreach: Tabs}\"></div>");
		const childContext = bindingContext.createChildContext(tabViewModel);
		ko.applyBindingsToDescendants(childContext, element);
		return {
			controlsDescendantBindings: true
		};
	}
};
